import { useSelector } from 'react-redux'
import { IReduxState } from 'interfaces/IReduxState'
import BaseAutocomplete from './baseAutocomplete'
import { IPremix, Premix } from 'interfaces/IPremix'
import { Department } from 'enums/department'
import { isUserAdmin, isUserSuperuser } from 'shared/auth'
import { SERVICES, ACTIONS } from 'enums/modules'

const headers = [
  {
    id: 'premixId',
    numeric: false,
    disablePadding: true,
    label: 'Kode Ruahan',
    width: 'medium',
  },
  {
    id: 'premixName',
    numeric: false,
    disablePadding: false,
    label: 'Nama Ruahan',
    width: 'medium',
  },
  {
    id: 'stock',
    numeric: false,
    disablePadding: false,
    label: 'Stok',
    width: 'small',
  },
]
export default function LoadPremixAutocomplete(props: {
  name?: string
  onChange?: (premix: IPremix) => void
  disabled?: boolean
  required?: boolean
  showInactive?: boolean
  getMatchedData?: (premixes: IPremix[]) => void
  showDetailedTable?: boolean
  loadAll?: boolean
  department?: Department
}) {
  const { name, loadAll, department: propsDepartment } = props
  const userGroups = useSelector((state: IReduxState) => state.userGroups || [])

  const handleChange = (premix?: IPremix | null) => {
    props.onChange?.(premix ?? new Premix({}))
  }

  const groupAccessMapping = useSelector(
    (state: IReduxState) => state.groupAccessMapping || {}
  )

  const isSuperuser = isUserSuperuser(userGroups)
  const isAdmin = isUserAdmin(userGroups)
  const isProductionManagerOT = userGroups.includes('ProductionManagerOT')
  const isProductionManagerKosmetik =
    userGroups.includes('karlina') || userGroups.includes('Production Manager')

  const hasAccessToKosmetik = userGroups.some((group) => {
    const lowerGroup = group.toLowerCase()
    return groupAccessMapping[lowerGroup]?.some(
      (p: any) =>
        p.service === SERVICES.inventoryKosmetik ||
        (p.service === SERVICES.production &&
          p.action === ACTIONS.productionFormListPremixKosmetik)
    )
  })
  const hasAccessToOt = userGroups.some((group) => {
    const lowerGroup = group.toLowerCase()
    return groupAccessMapping[lowerGroup]?.some(
      (p: any) =>
        p.service === SERVICES.inventoryOt ||
        (p.service === SERVICES.production &&
          p.action === ACTIONS.productionFormListPremixOt)
    )
  })

  const department =
    propsDepartment ||
    (isSuperuser ||
    isAdmin ||
    (hasAccessToKosmetik && hasAccessToOt) ||
    (isProductionManagerOT && isProductionManagerKosmetik)
      ? undefined
      : isProductionManagerOT || (hasAccessToOt && !hasAccessToKosmetik)
      ? Department.OT
      : isProductionManagerKosmetik || (hasAccessToKosmetik && !hasAccessToOt)
      ? Department.KOSMETIK
      : undefined)

  const url = '/premix/getPremix'

  const responseMapper = (premix: IPremix) => {
    return `${premix.premixId} - ${premix.premixName}`
  }

  return (
    <BaseAutocomplete
      {...props}
      url={url}
      extraParams={department ? { department } : {}}
      headers={headers}
      label="Kode Ruahan"
      loadAll={loadAll}
      name={name}
      responseMapper={responseMapper}
      onChange={handleChange}
      loadBySearch={true}
    />
  )
}
